import { render } from "./UserResetPassword.vue?vue&type=template&id=2c24f429"
import script from "./UserResetPassword.vue?vue&type=script&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&lang=js"

import "./UserResetPassword.vue?vue&type=style&index=0&id=2c24f429&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/koningsnvteaching/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__